import { FC, useEffect, useState } from "react"
import ClearIcon from "@mui/icons-material/Clear"
import { IconButton, InputAdornment } from "@mui/material"

import USearch from "./USearch"

const UTableSearch: FC<{
  onSearch?: (value: string) => void | undefined
  searchText: string
  onClear?: () => void
}> = ({ onSearch, searchText, onClear }) => {
  const [search, setSearch] = useState<string>("")

  useEffect(() => {
    setSearch(searchText)
  }, [searchText])

  const clearAdornment =
    onClear && search ? (
      <InputAdornment position="end">
        <IconButton size="small" onClick={() => {
          setSearch("")
          onClear()
        }}>
          <ClearIcon fontSize="small" />
        </IconButton>
      </InputAdornment>
    ) : null

  return (
    <USearch
      sxProp={{
        height: "40px",
        backgroundColor: "background.default",
        ".MuiInputBase-root": {
          height: "inherit  ",
        },
        ".MuiFormLabel-root": {
          top: "-6px",
          width: "100%",
        },
        ".MuiInputLabel-shrink": {
          top: 0,
        },
      }}
      search={search}
      updateSearch={(search: string) => {
        setSearch(search)
        onSearch && onSearch(search)
      }}
      endAdornmentIcon={clearAdornment}
    />
  )
}

export default UTableSearch
